import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';
import { useAuthState } from 'features/auth/hooks/federatedAuthHooks';
import { LoginFederated } from './LoginFederated';

export const AuthLoaderFederated = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, isLoading } = useAuthState();

  if (isLoading) {
    return (
      <Center>
        <CircularProgress />
      </Center>
    );
  }

  if (!isAuthenticated) {
    return <LoginFederated />;
  }

  return children;
};

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: #fbf9f7;
`;
